import { Link } from 'react-router-dom';
import './Footer.css'
const Footer =  (props) => {
    return (
        <footer className="page-footer font-small blue pt-4">
            <div className="footer-copyright text-center py-3">
                Atualizado em Março 2023
            </div>

        </footer>
    )
};

export default Footer